import { gql } from '@apollo/client';

export const AUTHORIZE_FROM_CONTEXT = gql`
  mutation AuthorizeFromContext($contextId: String!, $isSelfService: Boolean) {
    authorizeFromContext(contextId: $contextId, isSelfService: $isSelfService) {
      token
    }
  }
`;
